import {useState} from "react";
import useAxios from "axios-hooks";
import DeleteConfirmationDialog from "../../../Util/DeleteConfirmationDialog";

const DeleteStepModal = ({
  showModal,
  toggleShowModal,
  onDelete,
  stepId,
  setErrorMsg,
  setShowError,
  setShowSuccess,
  stepTitle,
}) => {
  const [errorMessage, setErrorMessage] = useState("");
  const [{ loading }, executeDelete] = useAxios(
    {
      method: "delete",
      url: `/courses/crs-steps-delete`,
      data: { crsStepId: stepId },
    },
    { manual: true }
  );

  const handleDelete = async () => {
    try {
      const response = await executeDelete();
      if (response?.status >= 200 && response?.status < 300) {
        setErrorMessage("");
        onDelete?.();
        toggleShowModal();
        setShowSuccess?.(true);
        setTimeout(() => {
          setShowSuccess?.(false);
          window.location.reload();
        }, 2000);
        return true;
      }
    } catch (error) {
      const apiMessage =
        error?.response?.data?.message || error?.response?.data || error?.message;
      const resolvedMessage =
        apiMessage || "Unable to delete this step. Please try again.";

      setErrorMessage(resolvedMessage);
      setShowError?.(true);
      setErrorMsg?.(resolvedMessage);
    }

    return false;
  };

  const expectedValue = stepTitle || "delete";

  return (
    <DeleteConfirmationDialog
      isVisible={showModal}
      onDismiss={() => {
        setErrorMessage("");
        toggleShowModal();
      }}
      onConfirm={handleDelete}
      resourceName={stepTitle}
      resourceType="step"
      confirmationValue={expectedValue}
      isDeleting={loading}
      errorMessage={errorMessage}
    />
  );
};

export default DeleteStepModal;      